import { CustomContractGroupMovementDebitCardDTO } from "../Cards/cardDTO";
import { CustomContractBaseDTO } from "../Contracts/contractDTO";
import { DocumentTransportLoadDTO, DocumentTransportUnloadDTO } from "../documents/DocumentBuilderDTO";
import { CustomEmployeeDTO } from "../employees/employeeDTO";
import { CutomMovementVehicleDTO } from "../Vehicles/VehicleDTO";

export interface MovementDTO {
  code?: string;
  entityToken?: string;
  rankOrder?: number;
  contract: CustomContractBaseDTO; //CONTRACT DTO
  creditMovement?: CustomContractMovementCreditDTO;
  debitMovement?: CustomContractGroupMovementDebitDTO;
  amount?: number;
  volume?: number;
  createdBy?: string;
  createdOn?: string;
  movementTypeCode?: MovementTypeCode;
  movementTypeDescription?: string;
  transactionIdentifier?: string;
  movementDate?: Date;
  odometer?: number;
  workingHours?: number;
}

export interface CustomContractMovementCreditDTO {
  documentDate?: string;
  documentNumber?: string;
  plafondRuleCode?: string;
  plafondRuleDescription?: string;
}

export interface CustomContractGroupMovementDebitDTO {
  posCode?: string;
  posDate?: string;
  productGroupCode?: string;
  siteCode?: string;
  productGroupDescription?: string;
  siteDescription?: string;
  pumpNumber?: number;
  nozzleNumber?: number;
  documentCode?: string;
  productUnitPrice?: number;
  employee?: CustomEmployeeDTO;
  vehicle?: CutomMovementVehicleDTO;
  card?: CustomContractGroupMovementDebitCardDTO;
  productGroupColor?: string;
}

export enum MovementTypeCode {
  DEBIT = "DEBIT",
  CREDIT = "CREDIT",
}

export interface DocumentHeaderDTO {
  id?: number;
  documentDate?: string;
  siteCode?: string;
  siteDescription?: string;
  saleTypeCode?: string;
  saleTypeDescription?: string;
  posNumber?: PosNumberDTO;
  documentCode?: string;
  documentNumberOfLines?: number;
  documentNetAmount?: number;
  documentTaxAmount?: number;
  documentGrossAmount?: number;
  documentDiscountAmount?: number;
  documentTotalAmount?: number;
  documentInvoiceNumber?: string;
  documentSerieHash?: string;
  documentSerieHashPrint?: string;
  documentSerieHashControl?: string;
  documentSerieCertificateNumber?: string;
  partyCode?: string;
  partyName?: string;
  partyStreet?: string;
  partyPostalZipCode?: string;
  partyCity?: string;
  partyIsoCountryCode?: string;
  documentTypeCode?: string;
  documentTypePrefix?: DocumentTypePrefixDTO;
  documentTypeDescription?: string;
  documentSerieCode?: string;
  documentStatusCode?: string;
  documentStatusDescription?: DocumentStatusDescriptionDTO;
  documentToken?: string;
  documentTypeGroupCode?: string;
  partyVatin?: PartyVatinDTO;
}

export interface DocumentProductLineDetailsDTO extends DocumentHeaderDTO {
  documentLineCode?: string;
  documentLineNo?: number;
  documentLineQuantity?: number;
  documentLineUnitPriceNet?: number;
  documentLineUnitPriceGross?: number;
  documentLineNetAmount?: number;
  documentLineTaxAmount?: number;
  documentLineGrossAmount?: number;
  documentLineDiscountAmount?: number;
  documentLineTotalAmount?: number;
  documentLineCostPriceNet?: number;
  documentLineCostPriceGross?: number;
  documentLineProductCode?: string;
  documentLineProductColor?: string
  documentLineProductDescription?: string;
  documentLineProductShortDescription?: string;
  documentLineProductGroupCode?: string;
  documentLineProductGroupColor?: string;
  documentLineProductGroupDescription?: string;
  documentLineProductFamilyCode?: string;
  documentLineProductFamilyColor?: string;
  documentLineProductFamilyDescription?: string;
  documentLineFuelPump?: number;
  documentLineFuelNozzle?: number;
  documentLineFuelStartTotalizer?: number;
  documentLineFuelEndTotalizer?: number;
  documentLineFuelStartStoc?: number;
  documentLineFuelEndStock?: number;
  documentLineFuelDiffQuantity?: number;
  documentLineFuelDiffUnitPriceNet?: number;
  documentLineFuelDiffUnitPriceGross?: number;
  documentLineFuelDiffTotalNetAmount?: number;
  documentLineFuelDiffTotalGrossAmount?: number;
}

export interface DraftDocumentOutDTO {
  documentToken?: string;
  documentStatusToken?: string;
  documentDate?: string;
  documentTypeToken?: string;
  paymentModeCodes?: DocumentBuilderPaymentDTO[];
  posNumber?: number;
  party: DocumentPartyDTO;
  netAmount: number;
  taxAmount: number;
  grossAmount: number;
  discountAmount: number;
  totalAmount: number;
  comments?: string;
  saveDraft?: boolean;
  savePartyData?: boolean;
  lines: any;
  actionType: string;
  documentTransportLoad?: DocumentTransportLoadDTO;
  documentTransportUnload?: DocumentTransportUnloadDTO;
  totalChange: number;
}

export interface DocumentPartyDTO {
  vatin?: string;
  name?: string;
  street?: string;
  postalZipCode?: string;
  city?: string;
  isoCountryCode?: string;
  licensePlate?: string;
}

export interface BaseResponseDraftDocumentOutDTO extends DraftDocumentOutDTO {
  token: string;
  startDraftDate: string;
  documentToken: string;
}

export interface DocumentStatusDTO {
  token: string;
  code: string;
  description: string;
}

interface DocumentStatusDescriptionDTO {
  icon: string;
  style: string;
  value: string;
}

interface DocumentTypePrefixDTO {
  icon: string;
  value: string;
}

interface PartyVatinDTO {
  icon: string;
  value: string;
}

interface PosNumberDTO {
  icon: string;
  style: string;
  value: number;
}

interface DocumentBuilderPaymentDTO {
  paymentModeCode: string;
  amount: number;
  description: string;
}